<template>
	<layout>
		<div class="banner">
			<img src="../../assets/image/1.png" alt="" srcset="" />
		</div>
		<div class="section1">
			<div class="title">请在以下输入框中输入你想要注册的域名</div>
			<div class="select-input-warrp">
				<Input class="search-input" v-model="domain" clearable search enter-button="查域名"
					placeholder="请输入域名：如baidu.cn" @on-search="search" />
			</div>
		</div>
		<div class="section2">
			<template v-if="activeShow">
				<div class="tips">{{ activeList.title }}</div>
				<div class="active-wrap">
					<img class="activeImg" :src="activeList.imgUrl" alt="">
					<div class="active-text">
						<div class="c-5 f-14">{{ activeList.linkUrl }}</div>
					</div>
				</div>
			</template>
      <div class="reg-warn">
        <div class="reg-warn-center">
          <h3>任何组织或者个人注册、使用的域名中，不得含有下列内容：</h3>
          <div class="reg-warn-center-item">
            <div>
              <span>1、反对宪法所确定的基本原则的；</span>
              <span>2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
            </div>
            <div>
              <span>3、损害国家荣誉和利益的；</span>
              <span>4、煽动民族仇恨、民族歧视，破坏民族团结的；</span>
            </div>
            <div>
              <span>5、破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
              <span>6、散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
            </div>
            <div>
              <span>7、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
              <span>8、侮辱或者诽谤他人，侵害他人合法权益的；</span>
            </div>
            <div>
              <span>9、含有法律、行政法规禁止的其他内容的。</span>
            </div>
          </div>
        </div>
      </div>
			<div class="tips">域名买越多，省更多!</div>
			<div class="tips-d">
				建站、域名注册、轻松搞定，众多后缀优惠供您选择！
			</div>
			<p class="line"></p>
			<div class="domain-content">
				<div class="item">
					<div class="heder">
						<p class="hederImg">
							<img src="../../assets/image/4.png" alt="" />
						</p>
						<div class="heder-1">域名注册</div>
						<div class="heder-2">新注价格</div>
					</div>
					<div class="content">
						<div class="content-item" v-for="item in priceObj.priceList0" :key="item.id">
							<div class="con-item-left">¥{{ item.list[0].price }}/年</div>
							<div class="con-item-right">
								<div class="item-name">{{ item.suffix }}</div>
								<div class="item-dname">{{ item.mark }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="item item2">
					<div class="heder">
						<p class="hederImg">
							<img src="../../assets/image/3.png" alt="" />
						</p>
						<div class="heder-1">续费价格</div>
						<div class="heder-2">单年续费价格</div>
					</div>
					<div class="content">
						<div class="content-item" v-for="item in priceObj.priceList1" :key="item.id">
							<div class="con-item-left">¥{{ item.list[0].price }}/年</div>
							<div class="con-item-right">
								<div class="item-name">{{ item.suffix }}</div>
								<div class="item-dname">{{ item.mark }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="item item3">
					<div class="heder">
						<p class="hederImg">
							<img src="../../assets/image/5.png" alt="" />
						</p>
						<div class="heder-1">转入价格</div>
						<div class="heder-2">含一年续费价格</div>
					</div>
					<div class="content">
						<div class="content-item" v-for="item in priceObj.priceList2" :key="item.id">
							<div class="con-item-left">¥{{ item.list[0].price }}/年</div>
							<div class="con-item-right">
								<div class="item-name">{{ item.suffix }}</div>
								<div class="item-dname">{{ item.mark }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex-content" style="margin-top: 50px">
				<router-link class="more" to="/price">查看更多</router-link>
			</div>

			<div class="warning-section">
				<div class="section-title">注意事项</div>
				<div>
					<div class="text">1、注册域名请先阅读：
						<span @click="RulesModelShow = true" style="cursor:pointer">《{{'云创空间'+RulesTitle}}》</span>、
						<span @click="renewServiceModelShow = true" style="cursor:pointer">《{{'云创空间'+renewServiceTitle}}》</span>
<!--						<span @click="templateServiceModelShow = true" style="cursor:pointer">《{{'云创空间'+templateServiceTitle}}》</span>-->
						</div>
					<div class="text">2、CN域名注册后要经过CNNIC审核，如果审核不通过，则域名注册会被退回。</div>
				</div>
			</div>
		</div>

		<!-- 域名注册服务协议 -->
		<rule-modal
		:show.sync="RulesModelShow"
		:content="RulesContent"
		:title="RulesTitle"
		></rule-modal>
		<!-- 域名续费服务协议 -->
		<rule-modal
		:show.sync="renewServiceModelShow"
		:content="renewServiceContent"
		:title="renewServiceTitle"
		></rule-modal>

    <rule-modal
        :show.sync="templateServiceModelShow"
        :content="templateServiceContent"
        :title="templateServiceTitle"
    ></rule-modal>
	</layout>
</template>
<script>
import templateRules from "@/assets/rule/templateRules";
	import layout from "./components/layout.vue";
	import ruleModal from "components/ruleModal.vue";
	import {
		getDomainSuffix,
		getPriceList,
		getActivity,
		agreementList
	} from "api/domain.js";
	import {
		mapMutations,mapActions
	} from "vuex";
	export default {
		mdomain: "index",
		data() {
			return {
				bg: require("../../assets/image/banner.png"),
				domain: "",
				sufList: [],
				priceObj: {
					priceList0: [],
					priceList1: [],
					priceList2: [],
				},
				activeShow:true,
     			activeList:{},
				RulesModelShow:false,
				RulesContent:'',
				RulesTitle:'',
				renewServiceModelShow: false,
				renewServiceContent: '',
				renewServiceTitle: '',

        templateServiceModelShow: false,
        templateServiceContent: '',
        templateServiceTitle: '',
			};
		},
		components: {
			layout,
			ruleModal
		},
		created() {
			this.getAgreementList()
			this.ACT_DOMAIN_QUERY()
			this.req_getDomainSuffix();
			this.req_getPriceList(0);
			this.req_getPriceList(1);
			this.req_getPriceList(2);
			this.getActivityList()

      this.templateServiceTitle = templateRules.title;
      this.templateServiceContent = templateRules.content;
		},
		methods: {
			...mapActions(["ACT_DOMAIN_QUERY"]),
			...mapMutations(["MUT_TOKEN_INFO"]),
			getAgreementList(){
				agreementList([1,2]).then((res) => {
						const { code, data } = res;
						if(code === 200 && data.length>0){
							this.RulesContent = data[0].content
							this.RulesTitle = data[0].name
							this.renewServiceContent = data[1].content
							this.renewServiceTitle = data[1].name
						}
				});
			},
			req_getDomainSuffix() {
				getDomainSuffix().then((res) => {
					const {
						code,
						data
					} = res;
					if (code === 200) {
						this.sufList = data;
					}
				});
			},
			req_getPriceList(type) {
				getPriceList(type).then((res) => {
					const {
						code,
						data
					} = res;
					if (code === 200) {
						this.priceObj[`priceList${type}`] = data;
					}
				});
			},
			search() {
				if (!this.domain) {
				  this.$Message.warning("请输入要搜索的域名！");
				  return false;
				}

				if (!(this.domain.toLocaleLowerCase().endsWith(".cn") || this.domain.toLocaleLowerCase().endsWith(".中国"))) {
					this.$Message.warning("请输入CN|中国后缀的域名！");
					return false;
				}

				this.$router.push({
					path: "/search",
					query: {
						domain: this.domain
					}
				});
			},
			async getActivityList(){
				const { code, data } = await getActivity()
				if (code == 200) {
					if(data.bannerList.length>0){
					this.activeShow = true
					this.activeList = data.bannerList[0]
					}else{
					this.activeShow = false
					}
				}
			}
		},
	};
</script>
<style lang="less" scoped>
	.banner {
		margin-top: 89px;
		img {
			height: 500px;
			width: 100%;
		}
	}

	.title {
		font-size: 20px;
		font-weight: 600;
		color: #000000;
		text-align: center;
	}

	.section1 {
		padding: 50px 0;

		.select-input-warrp {
			width: 800px;
			margin: 0 auto;
		}

		.section1-1 {
			width: 1200px;
			margin: 30px auto 0;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tool {
				display: flex;

				.tool-item {
					width: 70px;
					text-align: center;
					height: 30px;
					line-height: 30px;
					background-color: #f0f3f6;
					color: #333;
					margin-left: 10px;
					cursor: pointer;
				}

				.tool-item.active {
					color: #fff;
					background-color: #ff5c35;
				}
			}
		}

		.domain-warp {
			display: flex;
			flex-wrap: wrap;
			width: 1200px;
			margin: 0 auto;

			.item-domain:hover {
				background: url("../../assets/image/domain-active-bg.png") no-repeat;

				.item-d-right {
					div {
						color: #fff;
					}
				}
			}

			.item-domain {
				display: flex;
				width: 370px;
				height: 140px;
				background: url("../../assets/image/domain-defalt-bg.png") no-repeat;
				background-size: contain;
				cursor: pointer;
				transition: all 0.3s;
				margin-right: 45px;

				&:nth-child(3n) {
					margin-right: 0;
				}

				&:nth-child(n + 4) {
					margin-top: 40px;
				}

				.item-d-left {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 270px;
					padding: 48px 0;

					.price {
						font-size: 60px;
						color: #ff5c35;
						font-weight: bold;

						&::before {
							content: "¥";
							font-size: 24px;
							font-weight: bold;
							color: #ff5c35;
							margin-right: 6px;
						}
					}

					.info {
						margin-left: 20px;

						.info-t {
							font-size: 16px;
							font-weight: bold;
							color: #333333;
						}

						.info-d {
							margin-top: 6px;
							font-size: 12px;
							font-weight: 400;
							color: #999;
							transition: all 0.3s;
						}
					}
				}

				.item-d-right {
					flex: 0 0 100px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					div {
						font-size: 18px;
						font-weight: bold;
						color: #3992e9;
					}
				}
			}
		}
	}

	.section2 {
		padding: 50px 0 100px;
		// height: 1069px;
		// background: url("../../assets/image/index-bg.png") no-repeat;
		background-size: cover;

		.tips {
			text-align: center;
			color: #315491;
			font-weight: 600;
			font-size: 30px;
		}

		.tips-d {
			margin-top: 10px;
			text-align: center;
			font-size: 14px;
			font-weight: 600;
			color: #000000;
		}
		.active-wrap{
			width: 1200px;
			margin: 50px auto 50px;
			.active-text{
			margin-top: 20px;
			line-height: 30px;
			text-indent: 2em;
		}
			.activeImg{
			width: 1200px;
			}
		}
		.domain-content {
			width: 1170px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;

			.item.item2 {
				background: #8fb1eb;

				.heder {
					// background: url("../../assets/image/domain-item2-bg.png") no-repeat;
				}
			}

			.item.item3 {
				background: #759de6;

				.heder {
					// background: url("../../assets/image/domain-item3-bg.png") no-repeat;
				}
			}

			.item {
				// flex: 0 0 370px;
				width: 390px;
				background: #a9c3f0;

				.heder {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					text-align: center;
					// height: 110px;
					// background: url("../../assets/image/domain-item-bg.png") no-repeat;

					background-size: contain;

					.heder-1 {
						font-size: 20px;
						color: #ffffff;
						font-weight: bold;
					}

					.heder-2 {
						font-size: 16px;
						color: #ffffff;
						font-weight: 400;
					}
				}

				.content {
					// border: 2px solid #e8e8e8;
					border-top: 0;
					padding-bottom: 20px;

					.content-item {
						display: flex;
						// justify-content: space-between;
						align-items: center;
						padding: 15px 0;
						margin: 0 31px;

						// border-bottom: 2px solid #e8e8e8;
						&:last-child {
							border-bottom: none;
						}

						.item-name {
							font-size: 18px;
							font-weight: 400;
							color: #fff;
						}

						.item-dname {
							font-size: 14px;
							font-weight: 400;
							color: #fff;
						}
					}

					.con-item-right {
						font-size: 36px;
						font-weight: 400;
						color: #fff;
						margin-left: 20px;
					}
				}
			}
		}
		.warning-section{
			width: 1170px;
			margin: 30px auto;
			.section-title{
				font-size: 24px;
				font-weight: bold;
				color: #000;
				line-height: 48px;
			}
			.text{
				font-size: 18px;
				color: #000;
				line-height: 36px;
			}
			span{
				&:hover{
					color: #759DE6;
				}
			}
		}

		.more {
			width: 135px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			// background-color: #759DE6;
			color: #759DE6;
			border: 1px solid #759DE6;
			cursor: pointer;
		}
	}

	/deep/.search-input {
		margin-top: 50px;

		.ivu-input {
			height: 60px !important;
			padding: 0 70px 0 50px !important;
			font-size: 24px;
			line-height: 60px;
			width: 95%;
			// border-top-right-radius: 0;
			// border-bottom-right-radius: 0;
			border-radius: 30px;

			&:focus {
				box-shadow: none;
			}
		}

		.ivu-input-icon-clear {
			line-height: 60px;
			font-size: 24px;
		}

		.ivu-input-group-append {
			width: 125px;
			border-radius: 30px !important;
			background: #315491 !important;
		}

		.ivu-input-search:before {
			content: "";
			display: block;
			width: 0px !important;
			position: absolute;
			top: 0px;
			bottom: 0px;
			left: 0px;
			background: inherit;
		}
	}

	/deep/.ivu-input-icon {
		right: 45px;
	}

	.con-item-left {
		width: 60px;
		height: 48px;
		// background: #a9c3f0;
		border-radius: 5px 5px 5px 5px;
		opacity: 1;
		border: 1px solid #ffffff;
		text-align: center;
		line-height: 48px;
		color: #fff;
	}

	.hederImg {
		height: 112px;
		width: 112px;
		margin: 35px 0 25px 0;

		img {
			width: 100%;
			height: 112px;

		}
	}

	.line {
		width: 100px;
		height: 2px;
		background: #759DE6;
		margin: 30px auto 50px;
	}
  .reg-warn {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
  }
  .reg-warn-center h3 {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #000000;
  }
  .reg-warn-center-item div {
    padding-top: 20px;
  }
  .reg-warn-center-item span {
    display: inline-block;
    width: 500px;
    font-size: 16px;
  }
</style>
